import { createReducer, on } from '@ngrx/store';
import { immerOn } from 'ngrx-immer/store';
import { sessionUserData } from '../../interfaces/states-data';
import { __clearSessionUser, __updateSessionUser } from './session-user.actions';

const initialState: sessionUserData = {};

export const sessionUserReducer = createReducer(
    initialState,
    immerOn(__updateSessionUser, (state, newState) => {
        return newState;
    }),
    immerOn(__clearSessionUser, (state, newState) => {
        // Borrar estado del usuario del local storage
        localStorage.removeItem('sessionUserData');
        return { loggedIn: false };
    }),
)